import { createSlice } from '@reduxjs/toolkit'

import { switchCompany } from './sessionActions'
import { logout } from './userSlice'

const company = JSON.parse(localStorage.getItem('company'))

const initialState = { company: company ? company : {} }

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    // Not initialState: that is the company stored at page load
    resetCompany: () => ({ company: {} }),
    setCompany: (state, action) => {
      state.company = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(switchCompany, (state, action) => {
        state.company = action.payload.company
      })
      .addCase(logout, () => ({ company: {} }))
  },
})

export const { setCompany, resetCompany } = companySlice.actions
export default companySlice.reducer
